"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.read_fromLocalStorage = exports.write_toLocalStorage = exports.read = exports.write = void 0;
var diveSaver_bullets_sidecar_1 = require("./diveSaver_bullets-sidecar");
var diveSaver_crew_sidecar_1 = require("./diveSaver_crew-sidecar");
var diveSaver_objects_sidecar_1 = require("./diveSaver_objects-sidecar");
var diveSaver_splatters_sidecar_1 = require("./diveSaver_splatters-sidecar");
var diveSaver_tilemap_sidecar_1 = require("./diveSaver_tilemap-sidecar");
var diveStringSaver_sidecar_1 = require("./diveStringSaver-sidecar");
var version = 'v0.1.3';
var namespace = 'dive';
function write() {
    diveStringSaver_sidecar_1.diveStringSaver.reset();
    diveStringSaver_sidecar_1.diveStringSaver.wHeader(namespace, version);
    diveSaver_tilemap_sidecar_1.diveSaver_tilemap.write();
    diveSaver_crew_sidecar_1.diveSaver_crew.write();
    diveSaver_objects_sidecar_1.diveSaver_objects.write();
    diveSaver_splatters_sidecar_1.diveSaver_splatters.write();
    diveSaver_bullets_sidecar_1.diveSaver_bullets.write();
    // TODO: save splatters
    diveStringSaver_sidecar_1.diveStringSaver.wEnd(namespace);
    return diveStringSaver_sidecar_1.diveStringSaver.getResult();
}
exports.write = write;
function read(data) {
    diveStringSaver_sidecar_1.diveStringSaver.reset(data);
    diveStringSaver_sidecar_1.diveStringSaver.rHeader(namespace, version);
    diveSaver_tilemap_sidecar_1.diveSaver_tilemap.read();
    diveSaver_crew_sidecar_1.diveSaver_crew.read();
    diveSaver_objects_sidecar_1.diveSaver_objects.read();
    diveSaver_splatters_sidecar_1.diveSaver_splatters.read();
    diveSaver_bullets_sidecar_1.diveSaver_bullets.read();
    diveStringSaver_sidecar_1.diveStringSaver.rEnd(namespace);
}
exports.read = read;
function write_toLocalStorage() {
    var data = write();
    localStorage.setItem('dive', data);
    console.log('saved state', data.length, 'chars');
}
exports.write_toLocalStorage = write_toLocalStorage;
function read_fromLocalStorage() {
    var data = localStorage.getItem('dive');
    if (!data) {
        console.warn('no dive data found in localStorage');
        return false;
    }
    console.log('loaded state', data.length, 'chars');
    try {
        read(data);
    }
    catch (err) {
        console.error('failed to load dive data', err);
        return false;
    }
    return true;
}
exports.read_fromLocalStorage = read_fromLocalStorage;
